import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { required, rangeAmount } from '../../../../utils/validate';
import { formatAmount, toNumber } from '../../../../utils/formatters';
import Input from '../../../Forms/Input/input';
import { landingFormSubmitted } from '../../../../actions/loanApplicationActions';
import PropTypes from 'prop-types';
import { getCampaignFromEnvConfig } from '../../../../selectors';
import moneyFormatter from 'money-formatter';
import { memoize } from 'ramda';
import LoanPurposeField from "../../../LoanApplication/LoanPurposeFieldSet/loanPurposeField";

export const memoizeRangeAmount = memoize((min, max) => rangeAmount.bind(null, Number(min), Number(max)));

export const LandingForm = (props) => {
  const { handleSubmit, landingFormSubmitted, submitSucceeded, campaignData } = props;
  if (submitSucceeded) {
    return <Redirect push to="/apply/loan/check-your-rate"/>;
  }

  return (
    <form autoComplete="off" noValidate="novalidate" onSubmit={handleSubmit(landingFormSubmitted)} className="landing-form w-100">
      <div className="row align-items-center landing-form-row">
        <div className="col-sm-12 col-md-4">
          <Field
            name="loanAmount"
            label="Loan amount"
            component={Input}
            type="text"
            validate={[required, memoizeRangeAmount(campaignData.minLoanAmount, campaignData.maxLoanAmount)]}
            required={true}
            placeholder={`Request ${moneyFormatter.format('USD', campaignData.minLoanAmount, 0)} to ${moneyFormatter.format('USD', campaignData.maxLoanAmount, 0)}`}
            format={formatAmount}
            normalize={toNumber}
            styles={ { input: ["form-control-lg", "border-0", "bottom-shadow", "w-100"] } }
          />
        </div>

        <div className="col-sm-12 col-md-4">
          <LoanPurposeField styles={{ input: ["form-control-lg", "border-0", "bottom-shadow", "w-100"] }} />
        </div>

        <div className="col-sm-12 col-md-4 mb-auto">
          <button type="submit" data-track="checkrate-T" className="w-100 btn bcus-btn bcus-btn-secondary-dark-cyan bottom-shadow my-2">Check your rate</button>
          <Link to="/clapply/cl/CLLanding.action/invitation" data-track="invite-link-T" className="w-100 text-barclays-secondary-dark-cyan text-center invitation-code-link">Have an invitation code?</Link>
        </div>
      </div>
    </form>);
};

LandingForm.propTypes = {
  landingFormSubmitted: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitSucceeded: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  campaignData: getCampaignFromEnvConfig(state)
});

const mapDispatchToProps = { landingFormSubmitted };
export const ConnectedLandingForm = connect(mapStateToProps, mapDispatchToProps)(LandingForm);

export default reduxForm({
  form: 'openMarketLanding'
})(ConnectedLandingForm);
